export default __webpack_public_path__ + "static/media/selecticon.71a9709a.svg";